export default "/react/two-gis-608bf7a9.svg";